import { executeRequest, Request, Response } from '@jfs/network'
import { UPIType } from '../../data/models/UPI'
import { CARD_TYPE } from '../../utils/constants'
import { getAPIURL, getPaymentHeader } from '../config'
import { CardType } from './../../data/models/Card'

const responseParser = (response: Response) => {
  const { data } = response

  const userCards =
    data.card &&
    data.card?.map(
      (item: any) =>
        ({
          number: item?.maskedNumber,
          expmon: Number(item?.expiryMm),
          expyr: Number(item?.expiryYy),
          type:
            item?.type === CARD_TYPE.DEBIT_CARD
              ? 'DEBITCARD'
              : item?.type === CARD_TYPE.CREDIT_CARD
              ? 'CREDITCARD'
              : 'FOODCARD',
          nickname: item?.name,
          ownerName: item?.name,
          // isCvvLess: item?.cvvLess ? true : false,
          isCvvLess: false,
          token: String(item?.vaultId),
          id: Number(item?.bankId),
          issuer: '',
          issuerLogo: '',
          subType: String(item?.type),
          scheme: String(item?.scheme),
          product: String(item?.product),
          isDomestic: item?.isDomestic ?? true,
        } as CardType),
    )

  const foodCards =
    data.foodCard &&
    data.foodCard?.map(
      (item: any) =>
        ({
          number: item?.maskedNumber,
          expmon: Number(item?.expiryMm),
          expyr: Number(item?.expiryYy),
          type: 'FOODCARD',
          nickname: item?.name,
          ownerName: item?.name,
          token: String(item?.vaultId),
          id: Number(item?.bankId),
          issuer: '',
          issuerLogo: '',
          subType: String(item?.type),
          scheme: String(item?.scheme),
          paymentType: 'FOODCARD',
          cardBalance: {
            balance: '',
            isLoading: false,
            error: '',
          },
        } as CardType),
    )

  // const vpaList =
  //   data.upiVpa &&
  //   data.upiVpa.map((item: any) => {
  //     return {
  //       vpa: item.vpa,
  //     }
  //   })
  const vpaList =
    data.upiVpa &&
    data.upiVpa?.map((item: any, index: number) => {
      return {
        vpa: item.virtualPaymentAddress,
        id: index,
        paymentType: 'UPI',
        instrumentId: item.instrumentId,
      } as UPIType
    })
  return { userCards, vpaList, foodCards }
}

/**
 * New PG
 * It will return the list of saved cards
 * @param userDetails
 */
export const savedCard = (userDetails: any) => {
  const request: Request<{}> = {
    apiPath: getAPIURL('savedCards'),
    method: 'POST',
    body: userDetails,
    headers: getPaymentHeader(),
  }

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}
